import { observer } from "mobx-react-lite";
import { AdministrationLayout, UserList } from "../../../containers";
import "./UsersPage.less";
import { ConsentDecorator } from "../../../components/RoutesDecorator/ConsentDecorator";

const UsersPage: React.FC = () => {
    return (
        <ConsentDecorator>
            <AdministrationLayout title="Пользователи">
                <UserList className="qpd-rstr-users-page" showBackBtn={true}/>
            </AdministrationLayout>
        </ConsentDecorator>
    )
}

export default observer(UsersPage);